$shm_hitalama_map_widget_float_entity_field_settings $mol_pick
	opened? false

$shm_hitalama_map_widget_float_entity_field $shm_hitalama_map_widget_float
	scrollable false
	hide_head_tools true
	settings_layer? 0
	style *
		^
		zIndex <= settings_z_index \
	head_view /
	edges /
	controls /
		<= Field_row $mol_view
			sub /
				<= Field_title $mol_view
					sub / <= field_name \
				<= Field_type_title $mol_view
					sub / <= field_type_title \
				^ relation_summary_visible /
					<= Relation_summary $mol_view
						sub / <= relation_summary \
				<= Field_settings $shm_hitalama_map_widget_float_entity_field_settings
					opened? <=> settings_opened? false
					align \bottom_right
					hint \Настройки свойства
					trigger_content /
						<= Field_settings_icon $mol_icon_dots_vertical
					bubble_content /
						<= Field_settings_list $mol_list
							sub /
								<= Name_setting $mol_form_field
									name \Название
									Content <= Field_name $mol_string
										value? <=> field_name? \
								<= Type_setting $mol_form_field
									name \Тип
									Content <= Field_type $mol_select
										Filter null
										dictionary <= type_dictionary *
										value? <=> field_type? \string
								<= Required $mol_check_box
									title \Обязательное поле
									checked? <=> field_required? false
								^ target_settings /
									<= Target_field $mol_form_field
										name \Связанная сущность
										Content <= Target $mol_select
											Filter null
											dictionary <= target_dictionary *
											value? <=> target_id? \
								^ inverse_settings /
									<= Inverse_field $mol_form_field
										name \Обратное свойство
										Content <= Inverse $mol_select
											Filter null
											dictionary <= inverse_dictionary *
											value? <=> inverse_id? \
								<= Delete_controls $mol_view
									sub <= delete_controls /$mol_view
	Delete_ask $mol_button_minor
		title \Удалить свойство
		click? <=> field_delete_ask? null
	Delete_confirm $mol_button_major
		title \Удалить
		click? <=> field_delete_confirm? null
	Delete_cancel $mol_button_minor
		title \Отмена
		click? <=> field_delete_cancel? null
	delete_asked? false
